/**
 * @generated SignedSource<<2e9b3e986f3673a76c8fdcc2b82390bb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ReactionTooltip_members_Query$variables = {
  ids: ReadonlyArray<string>;
};
export type ReactionTooltip_members_Query$data = {
  readonly members: ReadonlyArray<{
    readonly email?: string;
    readonly id?: string;
    readonly name?: string;
    readonly " $fragmentSpreads": FragmentRefs<"UserAvatar_member" | "UserHandle_member">;
  } | null>;
};
export type ReactionTooltip_members_Query = {
  response: ReactionTooltip_members_Query$data;
  variables: ReactionTooltip_members_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "ids"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "ids",
    "variableName": "ids"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ReactionTooltip_members_Query",
    "selections": [
      {
        "alias": "members",
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "UserAvatar_member"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "UserHandle_member"
              }
            ],
            "type": "Member",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ReactionTooltip_members_Query",
    "selections": [
      {
        "alias": "members",
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "MemberAvatar",
                "kind": "LinkedField",
                "name": "avatar",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "url",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "roles",
                "storageKey": null
              }
            ],
            "type": "Member",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "ed69ebc3995a1cf29a803f15f0c7f219",
    "id": null,
    "metadata": {},
    "name": "ReactionTooltip_members_Query",
    "operationKind": "query",
    "text": "query ReactionTooltip_members_Query(\n  $ids: [ID!]!\n) {\n  members: nodes(ids: $ids) {\n    __typename\n    ... on Member {\n      id\n      name\n      email\n      ...UserAvatar_member\n      ...UserHandle_member\n    }\n    id\n  }\n}\n\nfragment UserAvatar_member on Member {\n  name\n  email\n  avatar {\n    url\n  }\n}\n\nfragment UserHandle_member on Member {\n  id\n  name\n  email\n  ...UserAvatar_member\n  ...UserInfoPopover_member\n}\n\nfragment UserInfoPopover_member on Member {\n  id\n  name\n  email\n  roles\n  ...UserAvatar_member\n}\n"
  }
};
})();

(node as any).hash = "2231abe4a03bb9c023e10481d389a790";

export default node;
